import { HubSpotForm } from './hubspot-form';
import { StripeForm } from './stripe-form';
import { CustomForm } from './custom-form';
import { PaypalForm } from './paypal-form';
import { Form } from './form';
import { FormTypes } from './form-types';
import { SubscriptionForm } from './subscription-form';
import { ProductForm } from './product-form';
import { DynamicSubscriptionForm } from './dynamic-subscription';
import { DonationForm } from './donation-form';
import { DiscountForm } from './discount-form';
import { QuantityForm } from './quantity-form';
import { AddonForm } from './addon-form';
import { AdaptivePricesForm } from './adaptive-prices-form';
import { AdaptiveSubscriptionPricesForm } from './adaptive-subscription-prices-form';
import { MultipleContactsForm } from './multiple-contacts-form';
import { StripeGooglePayForm } from './stripe-google-pay-form';
import { StripeApplePayForm } from './stripe-apple-pay-form';
import { RecaptchaV3Form } from './recaptcha-v3-form';
import { RecaptchaV2Form } from './recaptcha-v2-form';
import { TaxForm } from './tax-form';
import { OfflinePaymentForm } from './offline-payment-form';
import { LogFailingOnInitForm } from './z-log-failing-on-init';
import { LogFailingOnRenderForm } from './z-log-failing-on-render';
import { StripeAchForm } from './stripe-ach-form';
import { UpSellForm } from './upsell/upsell-form';
import { UpSellProductForm } from './upsell/upsell-product-form';
import { UpSellSubscriptionForm } from './upsell/upsell-subscription-form';
import { UpSellDonationForm } from './upsell/upsell-donation-form';
import { CountdownForm } from './countdown-form';
import { StripeBacsForm } from './stripe-bacs-form';
import { FacebookPixelForm } from './facebook-pixel-form';
import { GoogleAnalyticsForm } from './google-analytics-form';

export class FormsFactory {

    static createForm(formType: FormTypes, step: number | null = null): Form {
        switch (formType) {
            case FormTypes.Hubspot:
                return new HubSpotForm(step);
            case FormTypes.Stripe:
                return new StripeForm(step);
            case FormTypes.Stripe_Google_Pay:
                return new StripeGooglePayForm(step);
            case FormTypes.Stripe_Apple_Pay:
                return new StripeApplePayForm(step);
            case FormTypes.Stripe_Ach:
                return new StripeAchForm(step);
                case FormTypes.Stripe_Bacs:
                    return new StripeBacsForm(step);
            case FormTypes.Custom:
                return new CustomForm();
            case FormTypes.Paypal:
                return new PaypalForm(step);
            case FormTypes.Subscription:
                return new SubscriptionForm(step);
            case FormTypes.Product:
                return new ProductForm(step);
            case FormTypes.DynamicSubscription:
                return new DynamicSubscriptionForm();
            case FormTypes.DonationForm:
                return new DonationForm(step);
            case FormTypes.Discount:
                return new DiscountForm(step);
            case FormTypes.Quantity:
                return new QuantityForm();
            case FormTypes.Addon:
                return new AddonForm(step);
            case FormTypes.AdaptivePrices:
                return new AdaptivePricesForm();
            case FormTypes.AdaptiveSubscriptionPrices:
                return new AdaptiveSubscriptionPricesForm();
            case FormTypes.MultipleContacts:
                return new MultipleContactsForm();
            case FormTypes.RecaptchaV3:
                return new RecaptchaV3Form();
            case FormTypes.RecaptchaV2:
                return new RecaptchaV2Form();
            case FormTypes.Tax:
                return new TaxForm();
            case FormTypes.OfflinePayment:
                return new OfflinePaymentForm(step);
            case FormTypes.LogFailingOnInit:
                return new LogFailingOnInitForm();
            case FormTypes.LogFailingOnRender:
                return new LogFailingOnRenderForm();
            case FormTypes.UpSell:
                return new UpSellForm();
            case FormTypes.UpSellProduct:
                return new UpSellProductForm();
            case FormTypes.UpSellSubscription:
                return new UpSellSubscriptionForm();
            case FormTypes.UpSellDonation:
                return new UpSellDonationForm();
            case FormTypes.CountdownTimer:
                return new CountdownForm();
            case FormTypes.FacebookPixel:
                return new FacebookPixelForm();
            case FormTypes.GoogleAnalytics:
                    return new GoogleAnalyticsForm();
            default:
                throw new Error(`Form ${formType} is not supported`);
        }
    }

}
